import { FC } from "react";
import Layout from "../../layout/Layout";

const TermAndConditionsUser: FC<{}> = () => {
    return (
        <Layout>
            <div
                className="w-100 px-3 p_spaced"
                style={{ backgroundImage: "url(/assets/pages/contact/bg_contact.jpg)", backgroundSize: "contain" }}
            >
                <div className="container">
                    <div className="bg-white p-5">
                        <div className="side side_top mb-3">
                            <h2>Política de Privacidad</h2>
                        </div>
                        <p>
                            El presente documento, tiene por finalidad establecer los términos y condiciones de uso de
                            la Aplicación WCAR (la “Aplicación”) así como de su página web (el “Sitio Web y en conjunto
                            con la Aplicación, la “Plataforma Tecnológica”), desarrollos tecnológicos propiedad de WCAR
                            S.A.S., sociedad comercial identificada con Nit. 901566049 – 8 (en adelante la
                            “SociedadWCAR”).
                        </p>
                        <p>
                            Se le informa a quienes ingresen o se registren en la Plataforma Tecnológica (en adelante
                            los “Usuarios” o el “Usuario”), que el acceso a la misma implica el conocimiento,
                            comprensión y aceptación de los términos y condiciones generales de uso (“Términos y
                            Condiciones”) previstos en este documento. En caso de que el Usuario no esté de acuerdo,
                            deberá abstenerse de utilizar la Plataforma Tecnológica.
                        </p>
                        <p>
                            WCAR se reserva el derecho de actualizar o modificar los presentes Términos y Condiciones,
                            en cualquier momento en que lo considere necesario. Estas modificaciones estarán disponibles
                            al público a través de la página web wcar.co.
                        </p>

                        <div className="side side_top mb-3">
                            <h3>DEFINICIONES</h3>
                        </div>
                        <ul>
                            <li>
                                <strong>Comprador:</strong> Persona natural o jurídica que efectúa el pago de la reserva
                                y de la totalidad del precio del vehículo ofrecido en la Plataforma Tecnológica de WCAR.
                            </li>
                            <li>
                                <strong>Plataforma tecnológica:</strong> Hace referencia al desarrollo tecnológico que
                                despliega WCAR a favor del COMPRADOR, a través de una página web y aplicación móvil
                                denominada wcar.co que permite vincular a personas interesadas en vender un vehículo con
                                aquellas interesadas en adquirirlo. Adicionalmente, permite prestar servicios de
                                trámites de traspaso, intermediación en la consecución de créditos, entre otros.
                            </li>
                            <li>
                                <strong>Usuario:</strong> Toda Persona natural o jurídica que, como destinatario final,
                                usa la Plataforma Tecnológica de WCAR para interactuar con sus funcionalidades, y para
                                adquirir los vehículos ofrecidos mediante la Plataforma Tecnológica.
                            </li>
                            <li>
                                <strong>Vehículo:</strong> Hacer referencia al automotor usado ofrecido por el vendedor
                                a través de la Plataforma Tecnológica.
                            </li>
                            <li>
                                <strong>Vendedor:</strong> Persona natural o jurídica que tiene la calidad de
                                propietario de un vehículo y desea venderlo a través de la Plataforma tecnológica de
                                WCAR.
                            </li>
                        </ul>

                        <div className="side side_top mb-3">
                            <h3>SOBRE LA PLATAFORMA TECNOLÓGICA Y FUNCIONAMIENTO. </h3>
                        </div>

                        <p>
                            La Plataforma Tecnológica está compuesta por una aplicación para dispositivos móviles y una
                            página web, que permite vincular a personas interesadas en vender un vehículo con aquellas
                            interesadas en adquirirlo, y a su vez, prestar servicios de trámites de traspaso e
                            intermediación en la consecución de créditos para la compra de los vehículos ofrecidos en la
                            Plataforma Tecnológica.
                        </p>
                        <p>
                            El Usuario declara y acepta que en cualquier momento y sin previo aviso, WCAR podrá
                            modificar el diseño, los visuales y el arte de la Plataforma Tecnológica.
                        </p>

                        <div className="side side_top mb-3">
                            <h3>ACCESO A LA PLATAFORMA TECNOLÓGICA. </h3>
                        </div>
                        <p>
                            Las siguientes serán las restricciones y condiciones que el Usuario deberá observar durante
                            el uso y acceso a la Plataforma Tecnológica:{" "}
                        </p>
                        <ul>
                            <li>
                                Restricciones relacionadas con el uso de la Plataforma Tecnológica
                                <br />
                                <br />
                                El Usuario deberá abstenerse de: (i) utilizar la Plataforma Tecnológica con fines
                                inmorales o ilícitos; (ii) intentar probar la vulnerabilidad de una funcionalidad de la
                                Plataforma Tecnológica sin la debida autorización de WCAR, o violar las medidas de
                                seguridad o autenticación dispuestas en la Plataforma Tecnológica; (iii) intentar
                                interferir con las funcionalidades, servidor o red, incluyendo, pero sin limitarse al
                                envío de virus a través de la Plataforma Tecnológica o sobrecarga de tráfico para
                                denegación del servicio; (iv) suplantar la identidad de terceros de personas físicas o
                                jurídicas de cualquier índole; (v) proporcionar información de identidad incorrecta o
                                falsa; (vi) ofrecer Productos relacionados con actividades de explotación sexual,
                                pornografía, proxenetismo, el turismo sexual y demás formas de abuso sexual, imágenes o
                                videos con menores de edad, material que haga apología a la violencia, proselitismo
                                armado o actividades de personas o grupos al margen de la ley, o que atenten contra los
                                usos honestos y las buenas costumbres.
                                <br />
                                <br />
                                WCAR se reserva el derecho a investigar la ocurrencia de cualquiera de las anteriores
                                situaciones, y el Usuario se compromete a cooperar con cualquier autoridad competente en
                                la persecución de las personas que presuntamente puedan estar involucradas en tales
                                acciones.
                            </li>
                            <li>
                                Restricciones relacionadas con la propiedad intelectual de la Plataforma Tecnológica.
                                <br />
                                <br />
                                El Usuario deberá abstenerse de: (i) copiar, modificar, adaptar, traducir, descompilar,
                                realizar ingeniería inversa o desensamblar cualquier parte del contenido y/o de las
                                funcionalidades y/o de la Plataforma Tecnológica; (ii) reproducir o modificar por
                                cualquier medio el contenido de la Plataforma Tecnológica; (iii) vender, licenciar,
                                sublicenciar o explotar el contenido y/o cualquier tipo de acceso y/o uso de la
                                Plataforma Tecnológica.{" "}
                            </li>
                        </ul>
                        <div className="side side_top mb-3">
                            <h3>OBLIGACIONES DEL USUARIO.  </h3>
                        </div>
                        <ul>
                            <li>
                                El Usuario deberá acceder a la página web y/o descargar la Plataforma Tecnológica en su
                                dispositivo móvil, y deberá completar satisfactoriamente los procedimientos de registro.
                                Al registrarse se deberá asegurar de que toda la información proporcionada sea exacta,
                                esté actualizada, completa y válida;
                            </li>
                            <li>
                                El Usuario se compromete a: (ii) Utilizar la Plataforma Tecnológica de buena fe y solo
                                para los fines de los presentes términos y condiciones; (ii) abstenerse de utilizarla
                                para fines ilegales;
                            </li>
                            <li>
                                El Usuario reconoce que WCAR podrá actualizar los requisitos del hardware y software del
                                teléfono móvil de la Plataforma Tecnológica de forma periódica;
                            </li>
                            <li>
                                Abstenerse de afectar intencionalmente el funcionamiento normal de la red y/o intentar
                                dañar los Servicios y/o la Plataforma Tecnológica;
                            </li>
                            <li>
                                Responder frente a WCAR por cualquier inexactitud o falsedad respecto de las
                                fotografías, información y/o características suministradas para publicarse en la
                                Plataforma Tecnológica.
                            </li>
                        </ul>
                        <div className="side side_top mb-3">
                            <h3>OBLIGACIONES DE WCAR.   </h3>
                        </div>
                        <ul>
                            <li>
                                Emplear sus mejores oficios y esfuerzos, así como los conocimientos y experiencia
                                profesional de sus dependientes en la búsqueda, para formalizar la compra y venta del
                                Vehículo.
                            </li>
                            <li>
                                Utilizar sus herramientas tecnológicas para que a través de ella se ofrezcan y
                                comercialicen los Vehículos.
                            </li>
                            <li>
                                Publicar las fotografías e información del vehículo de propiedad del Vendedor en la
                                Plataforma Tecnológica, la cual incluye página web y/o aplicativo móvil, durante el
                                tiempo de vigencia de la relación comercial o hasta el momento en que se logré la venta
                                (lo que primero ocurra), utilizando única y exclusivamente a la información obtenida en
                                el peritaje previo realizado al vehículo.
                            </li>
                            <li>
                                Guardar absoluta reserva y confidencialidad, tanto a nivel personal como respecto ade
                                sus empleados o dependientes, de toda la información que sea suministrada por el
                                Usuario, obligación que se extiende a sus empleados, trabajadores, asesores, consultores
                                y contratistas.
                            </li>
                            <li>Cualquier gestión necesaria para el cumplimiento de su objeto social.</li>
                        </ul>
                        <div className="side side_top mb-3">
                            <h3>LIMITACIÓN DE RESPOSABILIDAD DE WCAR. </h3>
                        </div>
                        <ul>
                            <li>
                                Limitaciones sobre la disponibilidad de los Vehículos.
                                <br />
                                <br />
                                El Usuario reconoce que la reserva del vehículo no es una oferta vinculante ni elimina
                                el vehículo de la oferta disponible en la Plataforma tecnológica, por lo tanto, WCAR se
                                reserva el derecho de confirmar la disponibilidad en un plazo no superior a 24 horas,
                                contadas a partir de la recepción del pago.
                            </li>
                            <li>
                                Limitaciones por uso indebido de la Plataforma Tecnológica.
                                <br />
                                <br />
                                WCAR no será responsable por el uso inadecuado de la Plataforma debido a: (i)
                                utilización de hardware no compatibles con la Plataforma Tecnológica; (ii) caso omiso
                                por parte del Usuario respecto de las recomendaciones tecnológicas, manuales y/o
                                procedimientos que sean recomendados por WCAR para la correcta prestación de servicio.
                            </li>
                            <li>
                                Limitaciones respecto a la disponibilidad de la Plataforma Tecnológica.
                                <br />
                                <br />
                                WCAR no garantiza disponibilidad o el tiempo de operación de la Plataforma Tecnológica.
                                En caso de inestabilidad o inconveniente técnicos mayores, WCAR no tendrá
                                responsabilidad alguna frente al Usuario, pero hará sus mejores esfuerzos para
                                estabilizar su operatividad.
                            </li>
                        </ul>
                        <div className="side side_top mb-3">
                            <h3>SUSPENSIÓN DE LA PLATAFORMA.</h3>
                        </div>
                        <p>
                            En el caso en el que WCAR identifique que el Usuario está incumpliendo con las obligaciones
                            y/o deberes establecidos en los presentes Términos y Condiciones, podrá unilateralmente
                            suspender el uso de la Plataforma Tecnológica al Usuario.{" "}
                        </p>
                        <div className="side side_top mb-3">
                            <h3>DURACIÓN DE TÉRMINOS Y CONDICIONES. </h3>
                        </div>
                        <p>
                            Estos términos y condiciones tendrán una duración indefinida. WCAR se reserva el derecho de
                            actualizar o modificar los presentes Términos y Condiciones, en todo caso los trámites de
                            compra y venta se regirán por la versión de los Términos y Condiciones que se encuentre
                            vigente en la fecha de reserva del vehículo.{" "}
                        </p>
                        <div className="side side_top mb-3">
                            <h3>SERVICIO AL CLIENTE. </h3>
                        </div>
                        <p>
                            El Usuario podrá notificar a WCAR cualquier PQRS relacionado con los Términos y Condiciones
                            aquí previstos, comunicándose directamente con atención al cliente al Correo electrónico:
                            servicioalcliente @wcar.co{" "}
                        </p>
                        <div className="side side_top mb-3">
                            <h3>DERECHOS DE PROPIEDAD INTELECTUAL. </h3>
                        </div>
                        <p>
                            Excepto por lo expresamente establecido en estos Términos y Condiciones, nada de lo aquí
                            establecido se considerará que efectúa la transferencia, cesión o asignación de cualquier
                            derecho de propiedad intelectual u otros derechos de propiedad de una Parte a la otra Parte.
                        </p>
                        <p>
                            Bajo ningún supuesto, los presentes Términos y Condiciones se podrán entender como
                            transferencia a cualquier título de la tecnología de la cual es propietaria WCAR, su matriz,
                            sus subsidiarias y/o compañías filiales. WCAR es el titular y conserva todos los derechos de
                            propiedad intelectual relacionados con la Plataforma Tecnológica.
                        </p>
                        <div className="side side_top mb-3">
                            <h3>INDEPENDENCIA DE LAS PARTES. </h3>
                        </div>
                        <p>
                            El Usuario y WCAR son personas independientes y nada en estos Términos y Condiciones tiene
                            la intención o crea algún tipo de empresa conjunta, sociedad, join venture o relación
                            empleador/empleado entre las Partes.{" "}
                        </p>
                        <div className="side side_top mb-3">
                            <h3>CASO FORTUITO O FUERZA MAYOR.</h3>
                        </div>
                        <p>
                            Ninguna de las Partes será responsable de cualquier retraso o incumplimiento de estos
                            Términos y Condiciones que resulte, directa o indirectamente, de caso fortuito o fuerza
                            mayor. Por "fuerza mayor” o “caso Fortuito” se entenderán todas las causas o acontecimientos
                            que escapen al control de cualquiera de las Partes y que no puedan preverse o que, si
                            pudieran preverse, no podrían evitarse y que se produzcan una vez aceptados los presentes
                            Términos y Condiciones e impidan, retarden obstaculicen el cumplimiento de las obligaciones
                            de alguna de las Partes.
                        </p>
                        <div className="side side_top mb-3">
                            <h3>INDEMNIDAD Y RESPONSABILIDAD.</h3>
                        </div>
                        <p>
                            Las Partes acuerdan mantenerse indemnes respecto de terceros que pudieran ser afectados por
                            el incumplimiento de estos Términos y Condiciones y la Ley Aplicable. En atención a la
                            obligación de mantenerse indemnes, responderán por los daños y/o perjuicios que sus acciones
                            u omisiones pudieran causar a terceros y por los que la otra Parte pudiere resultar
                            afectada.
                        </p>
                        <div className="side side_top mb-3">
                            <h3>CONFIDENCIALIDAD</h3>
                        </div>
                        <p>
                            Las Partes tratarán en forma estrictamente confidencial toda información no pública que
                            llegue a su conocimiento relacionada con estos Términos y Condiciones, incluyendo sin
                            limitarse, a la información personal, capacidad financiera y/o corporativa, entre otros.{" "}
                        </p>
                        <div className="side side_top mb-3">
                            <h3>DATOS PERSONALES.</h3>
                        </div>
                        <p>
                            El Usuario declara y acepta que para el desarrollo de las actividades aquí previstas es
                            posible que comparta datos personales que se encuentran en su poder con WCAR y con cualquier
                            interviniente necesario, lo que implica una transmisión de datos. En todo caso WCAR declara
                            que cumple con las obligaciones y los parámetros determinados por la ley 1581 de 2012 y sus
                            normas concordantes para el tratamiento de datos de trabajadores, proveedores y clientes, y
                            se limitará a lo establecido en la política de protección de datos disponible en
                            https://wcar.co/politica-de-privacidad/
                        </p>
                        <div className="side side_top mb-3">
                            <h3>RESOLUCIÓN DE CONFLICTOS.</h3>
                        </div>
                        <p>
                            Toda controversia o diferencia generada con ocasión de los presentes Términos y Condiciones
                            o su ejecución, se intentará resolver en primera instancia entre las Partes. Si
                            transcurridos treinta (30) días calendario de surgida la controversia ésta no se ha
                            resuelto, se intentará conciliación ante cualquier Centro de Conciliación autorizado de la
                            ciudad de Bogotá D.C. Si en esta instancia no se logra resolver la diferencia, las Partes se
                            someterán a los tribunales de la jurisdicción ordinaria de la ciudad de Bogotá D.C y a las
                            leyes colombianas.
                        </p>
                        <div className="side side_top mb-3">
                            <h3>LEY APLICABLE Y DOMICILIO CONTRACTUAL.</h3>
                        </div>
                        <p>
                            Para la interpretación y cumplimiento de los Términos y condiciones, las Partes se someten a
                            las Leyes de la República de Colombia. Para todos los efectos legales, el domicilio
                            contractual será la ciudad de Bogotá D.C.
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default TermAndConditionsUser;
